var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('property-filter',{attrs:{"hasFilter":_vm.hasFilter}}),_c('property-list-table',{attrs:{"hasFilter":_vm.hasFilter,"empty_initial_list":_vm.empty_initial_list,"setup_parameter":_vm.setup_parameter,"selectable":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }